export const MODAL = `modal`
export const MAP = `map`